/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { FunctionComponent } from 'react';
import InsightsIcon from '@mui/icons-material/Insights';
import { UserMenuContentProps } from 'openvsx-webui';
import { AnalyticsRoutes } from './analytics-routes';
import { useHasAnalyticsAccess } from './analytics-status-context';

/**
 * Account-menu entry into Registry Analytics, supplied as `PageSettings.elements.userMenuContent`
 * so the library renders it in both the desktop and the mobile account menu. Gated on the status
 * observed by `AnalyticsStatusProvider` around the avatar, so opening the menu never refetches.
 */
export const AnalyticsMenuItem: FunctionComponent<UserMenuContentProps> = ({ MenuEntry }) => {
  if (!useHasAnalyticsAccess()) {
    return null;
  }
  return (
    <MenuEntry to={AnalyticsRoutes.OVERVIEW} icon={InsightsIcon}>
      Registry Analytics
    </MenuEntry>
  );
};
